import mitt from "mitt";
import { onUnmounted } from "vue";

const emitter = mitt();

export function onBus(eventName, handler) {
  emitter.on(eventName, handler);
  onUnmounted(() => {
    emitter.off(eventName, handler);
  });
}

export const busEmit = emitter.emit;
